import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IdsModalModule, IdsIconModule } from '@ids/angular';

import { CoreModule } from '../core/core.module';
import { HeaderComponent } from './components/header/header.component';

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, IdsModalModule, IdsIconModule, CoreModule],
  exports: [HeaderComponent]
})
export class ApplicationTopModule {}
